<template>
  <div v-show="isShow"
       :class="[isFullScreen?'fullscreen-ochart':'','departmentOchart']"
       :style="`zIndex:${zIndex}`"
       @click="modifyZIndex">
    <div class="componentclose" @click="isShow=false">X</div>
    <div class="header">
      <div style="overflow:hidden">
        <h3>o-chart</h3>
        <span class="name">{{companyName}}--{{departmentName}}</span>
      </div>
      <div style="margin-right: 60px;padding: 4px 12px;">
        <el-button size="mini" type="primary" @click="saveRemark">保存详情</el-button>
        <el-button size="mini" type="primary" @click="showMoneyTable">薪酬</el-button>
        <el-button size="mini" type="primary" @click="open(serchOption,true)">刷新数据</el-button>
        <!-- <el-button size="mini" type="primary" @click="hideOchartInput = !hideOchartInput">{{hideOchartInput?'显示':'隐藏'}}ochart输入框</el-button> -->
        <el-button v-if="!isFullScreen" size="mini" type="primary" @click="isFullScreen=true">全屏展示</el-button>
        <el-button v-else size="mini" type="primary" @click="isFullScreen=false">半屏展示</el-button>
        <el-slider v-model="slider"></el-slider>
      </div>
      <div class="remark-box">
        <div v-if="companyRemark" class="remark">
          <span class="label">阿尔法认知（原公司备注）：</span>
          <el-input
            v-model="companyRemark.公司备注"
            type="textarea"
            :rows="3"
            placeholder="公司详情"
          ></el-input>
        </div>
        <div class="remark">
          <span class="label">部门详情：</span>
          <el-input
            v-model="department.部门备注"
            type="textarea"
            :rows="3"
            placeholder="部门详情"
          ></el-input>
        </div>
      </div>
    </div>
    <ochartComponent ref="ochartComponent"
                     :slider="slider"
                     @modifyZIndex="modifyZIndex"></ochartComponent>
    <el-dialog :visible.sync="showDepartmentMoney" style="z-index:1501" width="520px" :close-on-click-modal="false" :modal="false">
      <departmentMoneyTable ref="departmentMoneyTable"
                            :remark="false"
                            :analyze="false"
                            :company-name="companyName"
                            :department="departmentName"></departmentMoneyTable>
    </el-dialog>
  </div>
</template>
<script>
import ochartComponent from './ochartComponent'
import departmentMoneyTable from '../component/departmentMoneyTable'

export default {
  components: { ochartComponent, departmentMoneyTable },
  data() {
    return {
      isShow: false,
      isFullScreen: false,
      departmentName: '',
      companyName: '',
      slider: 100,
      chartData: {},
      department: {},
      showDepartmentMoney: false,
      serchOption: '',
      zIndex: '',
      companyRemark: { 公司备注: null },
    }
  },
  watch: {
    $route(to, from) {
      this.isShow = false
    },
  },
  methods: {
    async saveCompanyRemark() {},
    modifyZIndex() {
      this.zIndex = app.root.dragindex++
    },
    async open(obj = {}, isRefresh) {
      this.modifyZIndex()
      this.isFullScreen = false
      this.serchOption = obj
      if (obj.rid) {
        const res = await app.service('radish').fetch({ _id: obj.rid })
        const radish = res.data[0]
        if (!radish.公司) return this.$message.error('未填写公司，请先设置公司名称')
        if (!radish.部门) return this.$message.error('未填写部门，请先设置部门名称')
        this.departmentName = radish.部门
        this.companyName = radish.公司
      } else {
        if (!obj.companyName) return this.$message.error('未填写公司，请先设置公司名称')
        if (!obj.department) return this.$message.error('未填写部门，请先设置部门名称')
        this.departmentName = obj.department
        this.companyName = obj.companyName
      }
      this.$nextTick(_ => {
        this.$refs.ochartComponent.loadData(
          { companyName: this.companyName, departmentName: this.departmentName },
          isRefresh,
        )
        this.getDepartmentRemark()
      })
      this.isShow = true
    },
    async saveRemark() {
      const res = await app
        .service('company')
        .modifyDepartmentById({ query: { _id: this.department._id }, data: { 部门备注: this.department.部门备注 } })
      this.$message(res.msg)
      if (this.companyRemark) {
        await app.service('company').modifyCompany({
          query: { _id: this.companyRemark._id },
          data: { 公司备注: this.companyRemark.公司备注 },
        })
      }
    },
    async getDepartmentRemark() {
      const res = await app
        .service('company')
        .getDepartmentDetail({ 公司: this.companyName, 部门: this.departmentName })
      if (res.status === 'success') {
        if (res.data) {
          this.department = res.data
          this.companyRemark = res.company
        } else this.$message('未获取到此部门信息')
      }
    },
    showMoneyTable() {
      this.showDepartmentMoney = true
    },
    async insertKPI() {
      this.$refs.ochartComponent.insertKPI()
    },
  },
}
</script>
<style>
.oc-export-btn {
  right: 140px;
  top: 0px;
}
.orgchart {
  background-image: none;
  display: block;
  float: left;
  border-radius: 7px;
}
.orgchart .node:hover {
  background-color: transparent;
}
.orgchart .node.focused {
  background-color: transparent;
}
.orgchart .node {
  width: auto;
  margin: 0;
  background-color: transparent;
  border-radius: 5px;
}
.orgchart .node .edge {
  color: #2b90d7;
  display: block;
}
.orgchart .node .rightEdge {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: -24px;
  margin: auto;
}
.orgchart .node .leftEdge {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: -24px;
  margin: auto;
}
.orgchart .node .bottomEdge {
  position: absolute;
  bottom: -10px;
  transform: translateX(-4px);
  margin: auto;
}
.orgchart .node .topEdge {
  transform: translateX(-9px);
}

.edge {
  position: relative;
  z-index: 0;
}
.orgchart tr.lines .leftLine,
.orgchart tr.lines .topLine,
.orgchart tr.lines .rightLine {
  border-color: #50a1f1;
}
.orgchart tr.lines .downLine {
  background-color: #50a1f1;
}
.remark .el-input input {
  padding: 0 3px;
  border: 0;
}
#ochart-input-box .el-input .el-input__inner {
  border-color: #2b90d7;
}
</style>
<style src='../../statistics/css/departmentOchart.css' scoped></style>
